import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrendingInsights = ({ articles }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold font-heading text-gray-900">
          Trending Insights
        </h2>
        <div className="flex items-center space-x-1 text-red-500">
          <Icon name="TrendingUp" size={20} />
          <span className="text-sm font-medium">Hot Topics</span>
        </div>
      </div>

      <div className="space-y-3 sm:space-y-4">
        {articles.map((article, index) => (
          <div key={article.id} className="flex items-start space-x-3 p-3 sm:p-4 rounded-lg hover:bg-gray-50 transition-colors duration-200">
            <div className="flex-shrink-0">
              <span className="inline-flex items-center justify-center w-6 h-6 sm:w-8 sm:h-8 bg-red-500 text-white rounded-full text-xs sm:text-sm font-bold">
                {index + 1}
              </span>
            </div>

            <div className="flex-1 min-w-0">
              <Link
                to={`/insights-blog/${article.slug}`}
                className="block hover:text-blue-600 transition-colors duration-200"
              >
                <h3 className="text-sm font-semibold text-gray-900 mb-1 line-clamp-2 leading-tight">
                  {article.title}
                </h3>
              </Link>

              <div className="flex flex-wrap items-center gap-2 sm:gap-3 text-xs text-gray-600">
                <span className="flex items-center space-x-1 whitespace-nowrap">
                  <Icon name="Eye" size={12} />
                  <span>{article.views}</span>
                </span>
                <span className="flex items-center space-x-1 whitespace-nowrap">
                  <Icon name="MessageCircle" size={12} />
                  <span>{article.comments}</span>
                </span>
                <span className="flex items-center space-x-1 whitespace-nowrap">
                  <Icon name="Share2" size={12} />
                  <span>{article.shares}</span>
                </span>
              </div>
            </div>

            <div className="flex-shrink-0">
              <Image
                src={article.image}
                alt={article.title}
                className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg object-cover"
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-4 border-t border-gray-200">
        <Link
          to="/insights-blog/trending"
          className="inline-flex items-center space-x-2 text-blue-600 hover:text-blue-800 transition-colors duration-200"
        >
          <span className="text-sm font-medium">View All Trending</span>
          <Icon name="ArrowRight" size={16} />
        </Link>
      </div>
    </div>
  );
};

export default TrendingInsights;